module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8smcx"))).then(() => parcelRequire('f4eak'));